import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IAllergyIntolerance, IPatient } from '@ahryman40k/ts-fhir-types/lib/R4';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { CAN_NOT_START_WITH_WHITE_SPACE } from '../../../../shared/regular-expressions/regex';

@Component({
  selector: 'inc-allergy-add',
  templateUrl: './allergy-add.component.html',
  styleUrls: ['./allergy-add.component.scss'],
})
export class AllergyAddComponent implements OnInit {
  @Input() inData: IAllergyIntolerance[];
  @Input() patient: IPatient;
  @Output() callSave: EventEmitter<IAllergyIntolerance> = new EventEmitter<IAllergyIntolerance>();
  @Output() callDelete: EventEmitter<string> = new EventEmitter<string>();

  form: FormGroup;

  constructor() { }

  ngOnInit() {
    this.reset();
  }

  reset(): void {
    this.form = this.resetForm();
  }

  resetForm(): FormGroup {
    return new FormGroup({
      code: new FormGroup({
        text: new FormControl('', Validators.compose([Validators.required, Validators.pattern((CAN_NOT_START_WITH_WHITE_SPACE))]))
      }),
      patient: new FormGroup({
        reference: new FormControl(this.patient.id)
      })
    });
  }

  save(inData: IAllergyIntolerance): void {
    this.callSave.emit(inData);
    this.reset();
  }

  delete(id: string): void {
    this.callDelete.emit(id);
  }
}
